/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 477);
/******/ })
/************************************************************************/
/******/ ({

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(document).ready(function () {

	var myWindowURL = 'http://maryknollsisters.org/light-a-candle';
	var myWindowTitle = 'I prayed with the Maryknoll Sisters.';
	var myWindowDescription = 'Today I lit a candle on the Maryknoll Sisters virtual votive chapel and said a prayer. Please join us in prayer, together we are making God\'s love visible.';
	var myWindowPicture = 'http://i63.tinypic.com/1z3o0vo.jpg';

	if (window.location.href.indexOf('World+Peace') > -1) {
		myWindowTitle = 'I prayed for World Peace with the Maryknoll Sisters.';
		$('.share-title').text(myWindowTitle);
		$('.facebook-button').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + myWindowURL + '&title=' + myWindowTitle + '&description=' + myWindowDescription + '&picture=' + myWindowPicture);
	}

	if (window.location.href.indexOf('Myself') > -1) {
		myWindowTitle = 'I prayed for myself with the Maryknoll Sisters.';
		$('.share-title').text(myWindowTitle);
		$('.facebook-button').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + myWindowURL + '&title=' + myWindowTitle + '&description=' + myWindowDescription + '&picture=' + myWindowPicture);
	}

	if (window.location.href.indexOf('Sympathy') > -1) {
		myWindowTitle = 'I prayed for sympathy with the Maryknoll Sisters.';
		$('.share-title').text(myWindowTitle);
		$('.facebook-button').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + myWindowURL + '&title=' + myWindowTitle + '&description=' + myWindowDescription + '&picture=' + myWindowPicture);
	}

	if (window.location.href.indexOf('The+Poor') > -1) {
		myWindowTitle = 'I prayed for the poor with the Maryknoll Sisters.';
		$('.share-title').text(myWindowTitle);
		$('.facebook-button').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + myWindowURL + '&title=' + myWindowTitle + '&description=' + myWindowDescription + '&picture=' + myWindowPicture);
	}

	if (window.location.href.indexOf('The+Sick') > -1) {
		myWindowTitle = 'I prayed for the sick with the Maryknoll Sisters.';
		$('.share-title').text(myWindowTitle);
		$('.facebook-button').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + myWindowURL + '&title=' + myWindowTitle + '&description=' + myWindowDescription + '&picture=' + myWindowPicture);
	}

	if (window.location.href.indexOf('The+Hungry') > -1) {
		myWindowTitle = 'I prayed for the hungry with the Maryknoll Sisters.';
		$('.share-title').text(myWindowTitle);
		$('.facebook-button').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + myWindowURL + '&title=' + myWindowTitle + '&description=' + myWindowDescription + '&picture=' + myWindowPicture);
	}

	if (window.location.href.indexOf('Hope') > -1) {
		myWindowTitle = 'I prayed for hope with the Maryknoll Sisters.';
		$('.share-title').text(myWindowTitle);
		$('.facebook-button').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + myWindowURL + '&title=' + myWindowTitle + '&description=' + myWindowDescription + '&picture=' + myWindowPicture);
	}
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.share-a-prayer.js